<template>
<div class="service-content">
  <div class="content">
    <div class="title-name">汽车金融解决专题</div>
    <div class="title-sub">橡诺根据不同的服务需求，严格遵循相关服务流程，在每个关键节点对服务成果进行监控，并持续进行修正，最终让客户满意</div>
    <div class="img">
      <img src="@/assets/img/af-solution/1.jpg" alt="">
      <img src="@/assets/img/af-solution/2.jpg" alt="">
      <img src="@/assets/img/af-solution/3.jpg" alt="">
      <img src="@/assets/img/af-solution/4.jpg" alt="">
      <img src="@/assets/img/af-solution/5.jpg" alt="">
      <img src="@/assets/img/af-solution/6.jpg" alt="">
      <img src="@/assets/img/af-solution/7.jpg" alt="">
      <img src="@/assets/img/af-solution/8.jpg" alt="">
      <img src="@/assets/img/af-solution/9.jpg" alt="">
    </div>
  </div>
  <Mission/>
</div>
</template>

<script>
import Mission from '@/components/Mission'
export default {
  name: '',
  components: {
    Mission
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      overflow: visible;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 18px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        width: 1039px;
        color: #666666;
        transform: .5s;
        line-height: 24px;
        text-align: center;
        font-size: 16px;
        box-sizing: border-box;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
      }
      .img{
        border-radius: 10px;
        overflow: hidden;
        margin-top: 50px;
        img{
          width: 100%;
          vertical-align: middle;
        }
      }
    }
}
</style>
